<!-- 首页 -->
<template>
  <div class="page_ index_ page_fixed_form_control_wrapper_ page_hide_upload_file_list_">
    <!-- 头部信息-->
    <publicHead></publicHead>
    <!-- 保费计算-->
    <riskInfo ref="riskInfo" :disabledAll="disabledAll"></riskInfo>
    <policyInfo v-show="agreementRead"></policyInfo>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import riskInfo from './components/riskInfo';
import policyInfo from './components/policyInfo';
import { indexMixin } from '@/mixins/indexMixin.js';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { riskInfo, policyInfo },
  mixins: [indexMixin],
  data() {
    //这里存放数据
    return {
      creator: '',
      productCode: '',
      plan: ''
    };
  }
};
</script>
<style lang="scss" scoped>
.page_ {
  .notice_ {
    white-space: pre-wrap;
  }
}

.flex_ {
  display: flex;
}

.btn_list {
  display: flex;
  justify-content: center;

  .btn_ {
    margin: 19px;
    border: 1px solid rgba(254, 143, 45, 1);
    width: 150px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;

    .btn_a {
      flex: 1;
      text-align: center;
      color: rgba(254, 143, 45, 1);
    }
  }
}

.btn_color {
  background: rgba(254, 143, 45, 1);
  border: 1px solid rgba(254, 143, 45, 1);
}

.gray_ {
  background: #555 !important;
  color: #fff !important;
  border: 1px solid #555 !important;
}

.index_ {
  margin: 30px auto;
  min-width: 1200px;
  width: 1200px;

  .letter_ {
    letter-spacing: 5px;
  }

  .title_ {
    margin: 30px 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .cutleft_ {
      font-size: 16px;
      font-family: Microsoft YaHei UI;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      // width: 10%;
    }

    .cutoff_ {
      // width:90%;
      flex: 1;
      height: 5px;
      background: #f0f0f0;
    }
  }
}

.level_ {
  width: 200px;
  margin: 10px;
}
.fixbg1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);

  .ant-spin-spinning {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
  }
}

.mg_left_20 {
  margin-left: 40px;
}

.down_excel {
  margin-left: 20px;
}

.new_insured {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  .con_ {
    width: 700px;
    padding: 20px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    margin: 0 auto;

    > p {
      font-weight: bold;
    }

    .btn_list {
      display: flex;
    }
  }
}

.operation {
  text-align: center;
}

.operation span {
  display: inline-block;
  background-color: #fe8f2d;
  color: #fff;
  border-radius: 3px;
  padding: 3px 10px;

  &:last-child {
    margin-left: 20px;
  }
}

.table_center th,
.table_center td {
  text-align: center;
}
</style>
